import React from 'react';
import PropTypes from 'prop-types';
import Header from '../components/Header';
import ExpoDesktop from '../components/ExpoDesktop';
import ExpoMobile from '../components/ExpoMobile';
import {withScreenCheck, withStore} from '../hoc';
/**
 * TagPage component
 */
class TagPage extends React.Component {
  static displayName = 'TagPage';
  static propTypes = {
    className: PropTypes.string,
    screen: PropTypes.string,
    tag: PropTypes.string.isRequired,
    store: PropTypes.object.isRequired,
  };
  static defaultProps = {
    className: 'TagPage',
  };

  /**
 * @override
 */
  render() {
    console.log('tag', this.props.tag);
    return (
      <div className={`${this.className} ${this.props.className || ''}`}>
        <Header {...this.props} />
        {this.props.screen === 'mobile' ? (
          <ExpoMobile tag={this.props.tag} {...this.props} />
        ) : (
          <ExpoDesktop tag={this.props.tag} {...this.props} />
        )}
      </div>
    );
  }
}

export default withScreenCheck(withStore(TagPage), 900);
